import React, { useContext } from 'react';
import { Icons } from '@miro-site/ui-design-system';
import { HeaderStateContext } from '../../context/header-state-context';
import { jsx as _jsx } from "react/jsx-runtime";
export var NavDrawerTrigger = function NavDrawerTrigger() {
  var _useContext = useContext(HeaderStateContext),
      openNavDrawer = _useContext.openNavDrawer;

  return /*#__PURE__*/_jsx("div", {
    className: "d-inline-block d-xl-none me-200 align-self-center cursor-pointer",
    children: /*#__PURE__*/_jsx("span", {
      className: "btn btn-link",
      onClick: openNavDrawer,
      children: /*#__PURE__*/_jsx(Icons.LinesThreeHorizontal, {
        className: "text-black",
        size: 300
      })
    })
  });
};